/** @fileoverview Provides the shared Fabrik application navigation bar. */

import type { ReactNode } from 'react';
import AccountMenu from '../AccountMenu';
import type { Tenant, User } from '../../types/identity';

type NavbarProps = {
  logoHref?: string;
  leading?: ReactNode;
  center?: ReactNode;
  children?: ReactNode;
};

type NavbarActionsProps = {
  user?: User;
  tenant?: Tenant;
  children?: ReactNode;
};

function IntegrtrLogo() {
  return (
    <>
      <img
        className="block w-24 object-contain dark:hidden"
        src="https://cdn.integrtr.com/logos/integrtr_logo_dark.png"
        alt="INTEGRTR"
      />
      <img
        className="hidden w-24 object-contain dark:block"
        src="https://cdn.integrtr.com/logos/integrtr_logo_light.png"
        alt=""
        aria-hidden="true"
      />
    </>
  );
}

export function FabrikNavbarActions({ user, tenant, children }: NavbarActionsProps) {
  return (
    <div className="ml-auto flex items-center gap-2">
      {children}
      {children && user && (
        <span className="mx-1 block h-6 w-px bg-current/20" aria-hidden="true" />
      )}
      {user && <AccountMenu user={user} tenant={tenant} />}
    </div>
  );
}

export default function FabrikNavbar({ logoHref, leading, center, children }: NavbarProps) {
  return (
    <header className="relative flex h-14 shrink-0 items-center gap-3 border-b border-app-border bg-app-surface-card px-6">
      {logoHref ? (
        <a href={logoHref} aria-label="Open Platform home">
          <IntegrtrLogo />
        </a>
      ) : (
        <IntegrtrLogo />
      )}
      <span className="block h-5 w-px bg-app-border" />
      {leading}
      {center && (
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">{center}</div>
      )}
      {children}
    </header>
  );
}
